module.exports = __webpack_public_path__ + "img/image_026.31bca6c0.jpg";